/*
 * @Descripttion:调用支付接口的函数
 * @Author: congz
 * @Date: 2020-06-10 19:03:02
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 17:51:36
 */

import axios from 'axios'

// 初始化支付信息（旧FM支付）
const initPayment = form =>
  axios.post('/api/v1/payments', form).then(res => res.data)

// 初始化DeepPay在线支付
const initOnlinePayment = form =>
  axios.post('/api/v1/pay/init-online-pay', form).then(res => res.data)

// 初始化 SveltPay 在线支付 (UPI)
const initSveltPayment = form =>
  axios.post('/api/v1/sveltpay/init', form).then(res => res.data)

// 用户点击 "Payment Done" 按钮的主动校验
const verifyPaymentDone = (orderNum, paymentId) =>
  axios
    .post(`/api/v1/orders/${orderNum}/pay`, {
      // 后端 PayOrderService.OrderNum 是 string，传数字会触发 JSON 类型不匹配
      order_num: String(orderNum),
      payment_id: paymentId
    })
    .then(res => res.data)

export { initPayment, initOnlinePayment, initSveltPayment, verifyPaymentDone }
